(function(){
  // Cart count
  function updateCartCount(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('.cart-count').forEach(function(el){
        el.textContent=c.item_count;
        el.style.display=c.item_count>0?'inline-flex':'none';
      });
    });
  }
  updateCartCount();

  // Mobile nav
  var toggle=document.getElementById('nav-toggle');
  var mobileNav=document.getElementById('mobile-nav');
  var mobileClose=document.getElementById('mobile-close');
  if(toggle&&mobileNav){
    toggle.addEventListener('click',function(){mobileNav.classList.add('open')});
    if(mobileClose)mobileClose.addEventListener('click',function(){mobileNav.classList.remove('open')});
  }

  // Product gallery
  var mainImg=document.getElementById('gallery-main-img');
  document.querySelectorAll('.thumb').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(mainImg)mainImg.src=btn.dataset.src;
      document.querySelectorAll('.thumb').forEach(function(b){b.classList.remove('active')});
      btn.classList.add('active');
    });
  });

  // Size selector
  document.querySelectorAll('.size-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(btn.classList.contains('soldout'))return;
      document.querySelectorAll('.size-btn').forEach(function(b){b.classList.remove('active')});
      btn.classList.add('active');
      var idInput=document.getElementById('variant-id');
      if(idInput)idInput.value=btn.dataset.variantId;
      var atcBtn=document.getElementById('atc-btn');
      if(atcBtn){atcBtn.disabled=false;atcBtn.textContent='Add to Bag'}
    });
  });

  // ATC form
  var atcForm=document.getElementById('atc-form');
  if(atcForm){
    atcForm.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=document.getElementById('atc-btn');
      var id=document.getElementById('variant-id');
      if(!id||!id.value){alert('Please select a size');return}
      var orig=btn.textContent;
      btn.textContent='Adding...';btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(id.value),quantity:1})})
        .then(function(r){return r.json()})
        .then(function(){
          btn.textContent='Added!';
          updateCartCount();
          setTimeout(function(){btn.textContent=orig;btn.disabled=false},1800);
        })
        .catch(function(){btn.textContent='Error';btn.disabled=false});
    });
  }

  // Accordion
  document.querySelectorAll('.accordion-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var body=btn.nextElementSibling;
      var open=btn.classList.contains('open');
      document.querySelectorAll('.accordion-btn.open').forEach(function(b){
        b.classList.remove('open');b.nextElementSibling.classList.remove('open');
      });
      if(!open){btn.classList.add('open');body.classList.add('open')}
    });
  });
})();
